// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 353 ? "reactPlayerPreview" : chunkId) + "." + {"353":"be0d58ec","488":"8a20a5a4"}[chunkId] + ".chunk.js";
};